import { useCallback } from "react";
import { useCustomDispatch } from "./hooks/redux";
import {
  setBackendClearLogOut,
  setBackendLogOut,
} from "./redux/slices/backend/login";
import { useNavigate } from "react-router";
import { RootState, persistor } from "./redux/store";
import { isLogin } from "./components/helper/isAuth";
import { useSelector } from "react-redux";
import { setBackendClearAcreditarHs } from "./redux/slices/backend/acreditarHs";
import { setBackendClearActualizarDisponibilidad } from "./redux/slices/backend/actualizarDisponibilidad";
import { setBackendClearActualizarNotificaciones } from "./redux/slices/backend/actualizarNotificaciones";
import { setBackendClearAdjuntar } from "./redux/slices/backend/adjuntarArchivo";
import { setBackendClearIngresarArchivo } from "./redux/slices/backend/adjuntosIngresarArchivo";
import { setBackendClearAsignarTareaManual } from "./redux/slices/backend/asignarTareaManual";
import { setBackendClearCasoPorId } from "./redux/slices/backend/casoPorId";
import { setBackendClearCasoActivoPorIdContext } from "./redux/slices/backend/casoActivoPorIdContext";
import { setBackendClearCasosActivosPorContratoId } from "./redux/slices/backend/casoActivosPorContratoId";
import { setBackendClearCasoArchivadoPorId } from "./redux/slices/backend/casoArchivadoPorId";
import { setBackendClearCasoArchivadoPorIdContext } from "./redux/slices/backend/casoArchivadoPorIdContext";
import { setBackendClearCasosPorCliente } from "./redux/slices/backend/casosPorCliente";
import { setBackendClearCategoriaPorId } from "./redux/slices/backend/categoriaPorId";
import { setBackendClearComentariosCasoActivo } from "./redux/slices/backend/comentariosCasoActivo";
import { setBackendClearComentariosCasoArchivado } from "./redux/slices/backend/comentariosCasoArchivado";
import { setBackendClearInsertarGuardia } from "./redux/slices/backend/insertarGuardia";
import { setBackendClearItemAcountManagerSaldoClearing } from "./redux/slices/backend/itemAcountManagerSaldoClearing";
import { setBackendClearItemClientePorContrato } from "./redux/slices/backend/itemClientePorContrato";
import { setBackendClearClienteResultado } from "./redux/slices/backend/itemClienteResultado";
import { setBackendClearClienteResultados } from "./redux/slices/backend/itemClienteResultados";
import { setBackendClearItemConfiguarcion } from "./redux/slices/backend/itemConfiguracion";
import { setBackendClearItemConsumoPorCaso } from "./redux/slices/backend/itemConsumoPorCaso";
import { setBackendClearItemContrato } from "./redux/slices/backend/itemContrato";
import { setBackendClearItemPonderacion } from "./redux/slices/backend/itemPonderacion";
import { setBackendClearProcesoPorCliente } from "./redux/slices/backend/itemProcesoPorCliente";
import { setBackendClearItemSaldoClearing } from "./redux/slices/backend/itemSaldoClearing";
import { setBackendClearItemTareaCatalogo } from "./redux/slices/backend/itemTareaCatalogo";
import { setBackendClearTipoTicketPorCliente } from "./redux/slices/backend/itemTipoTicketPorCliente";
import { setBackendClearListaCasosActivo } from "./redux/slices/backend/listaCasosActivo";
import { setBackendClearListaCasosActivosAllContratos } from "./redux/slices/backend/listaCasosActivosAllContratos";
import { setBackendClearListaCasosActivosPorContrato } from "./redux/slices/backend/listaCasosActivosPorContrato";
import { setBackendClearListaCasosArchivado } from "./redux/slices/backend/listaCasosArchivado";
import { setBackendClearListaCasosArchivadosAllContratos } from "./redux/slices/backend/listaCasosArchivadosAllContratos";
import { setBackendClearListaCasosArchivadosPorContrato } from "./redux/slices/backend/listaCasosArchivadosPorContrato";
import { setBackendClearListaTareaIdRecurso } from "./redux/slices/backend/listaTareaIdRecurso";
import { setBackendClearListaTareasAbiertasPorIdUsuario } from "./redux/slices/backend/listaTareasAbiertasPorIdUsuario";
import { setBackendClearListaTareasAbiertasPorUsuario } from "./redux/slices/backend/listaTareasAbiertasPorUsuario";
import { setBackendClearListaTareasAbiertasPorUsuarioCaso } from "./redux/slices/backend/listaTareasAbiertasPorUsuarioCaso";
import { setBackendClearListaTareasAbiertasTomadasPorUsuario } from "./redux/slices/backend/listaTareasAbiertasTomadasPorUsuario";
import { setBackendClearListaTareasAbiertasTomadasUsuario } from "./redux/slices/backend/listaTareasAbiertasTomadasUsuario";
import { setBackendClearListaTareasActivasCasoPorUsuario } from "./redux/slices/backend/listaTareasActivasCasoPorUsuario";
import { setBackendClearListaTareasCompletadasCasoPorUsuario } from "./redux/slices/backend/listaTareasCompletadasCasoPorUsuario";
import { setBackendClearListaTareasCompletadasPorCaso } from "./redux/slices/backend/listaTareasCompletadasPorCaso";
import { setBackendClearListaTareasCompletadasPorUsuario } from "./redux/slices/backend/listaTareasCompletadasPorUsuario";
import { setBackendClearListaTareasCompletadasUsuario } from "./redux/slices/backend/listaTareasCompletadasUsuario";
import { setBackendClearListaTareasEnEjecucionCaso } from "./redux/slices/backend/listaTareasEnEjecucionCaso";
import { setBackendClearListaTareasNoTomadasCaso } from "./redux/slices/backend/listaTareasNoTomadasCaso";
import { setBackendClearListaTareasRecurso } from "./redux/slices/backend/listaTareasRecurso";
import { setBackendClearListaTareasTomadasPorUsuario } from "./redux/slices/backend/listaTareasTomadasPorUsuario";
import { setBackendClearListaTareasTomadasRecurso } from "./redux/slices/backend/listaTareasTomadasRecurso";
import { setBackendClearModificarGuardia } from "./redux/slices/backend/modificarGuardia";
import { setClearObtenerArchivoAdjunto } from "./redux/slices/backend/obteneArchivo";
import { setBackendClearAdjuntosCaso } from "./redux/slices/backend/obtenerAdjuntosCaso";
import { setBackendClearObtenerCategorias } from "./redux/slices/backend/obtenerCategorias";
import { setBackendClearObtenerEstadoTareas } from "./redux/slices/backend/obtenerEstadoTareas";
import { setBackendClearObtenerGuardia } from "./redux/slices/backend/obtenerGuardia";
import { setBackendClearObtenerGuardiaCancelada } from "./redux/slices/backend/obtenerGuardiaCancelada";
import { setBackendClearObtenerGuardiaRealizada } from "./redux/slices/backend/obtenerGuardiaRealizada";
import { setBackendClearObtenerNotificaciones } from "./redux/slices/backend/obtenerNotificaciones";
import { setBackendClearPausaDiaria } from "./redux/slices/backend/obtenerPausaDiaria";
import { setBackendClearListaTareaRm } from "./redux/slices/backend/obtenerTareasRm";
import { setBackendClearListaEstadoUsuarios } from "./redux/slices/backend/obtenerEstadoUsuarios";
import { setBackendClearObtenerTiposMime } from "./redux/slices/backend/obtenerTiposMime";
import { setBackendClearObtenerTiposPausa } from "./redux/slices/backend/obtenerTiposPausa";
import { setBackendClearUsuarios } from "./redux/slices/backend/obtenerUsuarios";
import { setBackendClearUsuariosGuardia } from "./redux/slices/backend/obtenerUsuariosGuardia";
import { setBackendClearPausaExcedida } from "./redux/slices/backend/pausaExcedida";
import { setBackendClearPausarTarea } from "./redux/slices/backend/pausarTarea";
import { setClearRecuperarArchivoAdjunto } from "./redux/slices/backend/recuperarArchivoAdjunto";
import { setBackendClearRecursoContexto } from "./redux/slices/backend/recursoContexto";
import { setBackendClearReiniciarTarea } from "./redux/slices/backend/reiniciarTarea";
import { setClearRespuestaPausaExcedida } from "./redux/slices/backend/respuestaPausaExcedida";
import { setBackendClearServiceRequestActived } from "./redux/slices/backend/serviceRequestActived";
import { setBackendClearServiceRequestArchived } from "./redux/slices/backend/serviceRequestArchived";
import { setBackendClearTareaOperadorRef } from "./redux/slices/backend/tareaOperadorRef";
import { setBackendClearTareaPorId } from "./redux/slices/backend/tareaPorId";
import { setBackendClearTareaResolver } from "./redux/slices/backend/tareaResolver";
import { setBackendClearTareaResolverOperador } from "./redux/slices/backend/tareaResolverOperador";
import { setBackendClearTareasCasoActivo } from "./redux/slices/backend/tareasCasoActivo";
import { setBackendClearTareasCasoArchivado } from "./redux/slices/backend/tareasCasoArchivado";
import { setBackendClearTareaTiempoEstimRef } from "./redux/slices/backend/tareaTiempoEstimRef";
import { setBackendClearTareaTiempoRef } from "./redux/slices/backend/tareaTiempoRef";
import { setBackendClearTareaTomarLiberar } from "./redux/slices/backend/tareaTomarLiberar";
import { setBackendClearTareaTomarLiberarOperador } from "./redux/slices/backend/tareaTomarLiberarOperador";
import { setBackendClearTicketInsertar } from "./redux/slices/backend/ticketInsertar";
import { setBackendClearTicketModificar } from "./redux/slices/backend/ticketModificar";
import { setBackendClearUltimaTareaCasoActivo } from "./redux/slices/backend/ultimaTareaCasoActivo";
import { setBackendClearCustomFieldsContrato } from "./redux/slices/backend/obtenerCustomFieldsContrato";
import { setBackendClearObtenerEstadoUsuario } from "./redux/slices/backend/obtenerEstadoUsuario";
import { setBackendClearAsignarTareaAutomaticamente } from "./redux/slices/backend/asignarTareaAutomaticamente";
export const UseAppRouter = () => {
  const timeOut = Number(process.env.REACT_APP_TIMEOUT);
  const timeOutEstadoUsuario = Number(
    process.env.REACT_APP_TIMEOUT_ESTADO_USUARIO,
  );
  const timeOutModal = Number(process.env.REACT_APP_TIMEOUT_MODAL);

  const { IdPerfil } = useSelector((state: RootState) => state.login);
  const dispatchs = useCustomDispatch();
  const setStateInicialAllComponents = async () => {
    await dispatchs(setBackendClearObtenerEstadoUsuario());
    await dispatchs(setBackendClearAdjuntosCaso());
    await dispatchs(setClearObtenerArchivoAdjunto());
    await dispatchs(setBackendClearIngresarArchivo());
    await dispatchs(setBackendClearCustomFieldsContrato());
    await dispatchs(setBackendClearLogOut());
    await dispatchs(setBackendClearAcreditarHs());
    await dispatchs(setBackendClearAsignarTareaManual());
    await dispatchs(setBackendClearActualizarDisponibilidad());
    await dispatchs(setBackendClearAdjuntar());
    await dispatchs(setBackendClearActualizarNotificaciones());
    await dispatchs(setBackendClearCasoPorId());
    await dispatchs(setBackendClearCasosPorCliente());
    await dispatchs(setBackendClearCasoArchivadoPorIdContext());
    await dispatchs(setBackendClearItemAcountManagerSaldoClearing());
    await dispatchs(setBackendClearInsertarGuardia());
    await dispatchs(setBackendClearComentariosCasoArchivado());
    await dispatchs(setBackendClearComentariosCasoActivo());
    await dispatchs(setBackendClearCategoriaPorId());
    await dispatchs(setBackendClearCasoArchivadoPorId());
    await dispatchs(setBackendClearCasosActivosPorContratoId());
    await dispatchs(setBackendClearCasoActivoPorIdContext());
    await dispatchs(setBackendClearItemClientePorContrato());
    await dispatchs(setBackendClearClienteResultado());
    await dispatchs(setBackendClearClienteResultados());
    await dispatchs(setBackendClearItemConfiguarcion());
    await dispatchs(setBackendClearItemConsumoPorCaso());
    await dispatchs(setBackendClearItemContrato());
    await dispatchs(setBackendClearItemPonderacion());
    await dispatchs(setBackendClearProcesoPorCliente());
    await dispatchs(setBackendClearItemSaldoClearing());
    await dispatchs(setBackendClearItemTareaCatalogo());
    await dispatchs(setBackendClearTipoTicketPorCliente());
    await dispatchs(setBackendClearListaCasosActivo());
    await dispatchs(setBackendClearListaCasosActivosAllContratos());
    await dispatchs(setBackendClearListaCasosActivosPorContrato());
    await dispatchs(setBackendClearListaCasosArchivado());
    await dispatchs(setBackendClearListaCasosArchivadosAllContratos());
    await dispatchs(setBackendClearListaCasosArchivadosPorContrato());
    await dispatchs(setBackendClearListaTareaIdRecurso());
    await dispatchs(setBackendClearListaTareasAbiertasPorIdUsuario());
    await dispatchs(setBackendClearListaTareasAbiertasPorUsuario());
    await dispatchs(setBackendClearListaTareasAbiertasPorUsuarioCaso());
    await dispatchs(setBackendClearListaTareasAbiertasTomadasPorUsuario());
    await dispatchs(setBackendClearListaTareasAbiertasTomadasUsuario());
    await dispatchs(setBackendClearListaTareasActivasCasoPorUsuario());
    await dispatchs(setBackendClearListaTareasCompletadasCasoPorUsuario());
    await dispatchs(setBackendClearListaTareasCompletadasPorCaso());
    await dispatchs(setBackendClearListaTareasCompletadasPorUsuario());
    await dispatchs(setBackendClearListaTareasCompletadasUsuario());
    await dispatchs(setBackendClearListaTareasEnEjecucionCaso());
    await dispatchs(setBackendClearListaTareasNoTomadasCaso());
    await dispatchs(setBackendClearListaTareasRecurso());
    await dispatchs(setBackendClearListaTareasTomadasPorUsuario());
    await dispatchs(setBackendClearListaTareasTomadasRecurso());
    await dispatchs(setBackendClearModificarGuardia());
    await dispatchs(setBackendClearObtenerCategorias());
    await dispatchs(setBackendClearObtenerEstadoTareas());
    await dispatchs(setBackendClearObtenerGuardia());
    await dispatchs(setBackendClearObtenerGuardiaCancelada());
    await dispatchs(setBackendClearObtenerGuardiaRealizada());
    await dispatchs(setBackendClearObtenerNotificaciones());
    await dispatchs(setBackendClearPausaDiaria());
    await dispatchs(setBackendClearListaTareaRm());
    await dispatchs(setBackendClearListaEstadoUsuarios());
    await dispatchs(setBackendClearObtenerTiposMime());
    await dispatchs(setBackendClearObtenerTiposPausa());
    await dispatchs(setBackendClearUsuarios());
    await dispatchs(setBackendClearUsuariosGuardia());
    await dispatchs(setBackendClearPausaExcedida());
    await dispatchs(setBackendClearPausarTarea());
    await dispatchs(setClearRecuperarArchivoAdjunto());
    await dispatchs(setBackendClearRecursoContexto());
    await dispatchs(setBackendClearReiniciarTarea());
    await dispatchs(setClearRespuestaPausaExcedida());
    await dispatchs(setBackendClearServiceRequestActived());
    await dispatchs(setBackendClearServiceRequestArchived());
    await dispatchs(setBackendClearTareaOperadorRef());
    await dispatchs(setBackendClearTareaPorId());
    await dispatchs(setBackendClearAsignarTareaAutomaticamente());
    await dispatchs(setBackendClearTareaResolver());
    await dispatchs(setBackendClearTareaResolverOperador());
    await dispatchs(setBackendClearTareasCasoActivo());
    await dispatchs(setBackendClearTareasCasoArchivado());
    await dispatchs(setBackendClearTareaTiempoEstimRef());
    await dispatchs(setBackendClearTareaTiempoRef());
    await dispatchs(setBackendClearTareaTomarLiberar());
    await dispatchs(setBackendClearTareaTomarLiberarOperador());
    await dispatchs(setBackendClearTicketInsertar());
    await dispatchs(setBackendClearTicketModificar());
    await dispatchs(setBackendClearUltimaTareaCasoActivo());
  };
  const limpiarLocalStorage = () => {
    persistor.purge().then(() => {
      console.log("Local Storage limpiado");
    });
  };
  let is_Login = isLogin();

  const navigate = useNavigate();
  const navigateTo = (routeUrl: string) => {
    const url = `${routeUrl}`;
    navigate(url);
  };

  const handleBackendLogOut = useCallback(async (): Promise<void> => {
    await dispatchs(setBackendLogOut(IdPerfil));
    sessionStorage.clear();
    sessionStorage.setItem("authenticated", "false");
    sessionStorage.removeItem("authenticated");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("persist:root");
    sessionStorage.removeItem("root");
    await limpiarLocalStorage();
    await setStateInicialAllComponents();
    document.title = "";
    const INTEVALO_MODAL_Ok = Number(process.env.REACT_APP_INTEVALO_MODAL_Ok);

    setTimeout(function () {
      navigateTo("/login");
    }, INTEVALO_MODAL_Ok);
  }, [dispatchs]);

  const signOut = async () => {
    await handleBackendLogOut();
  };

  return {
    timeOut,
    timeOutEstadoUsuario,
    timeOutModal,
    signOut,
    is_Login,
  };
};
